import { ReactElement } from 'react'
import { APPLICATION_MAX_WIDTH } from '../../constants'
import { mentorLogos } from '../../assets/mentors/logos'
import { Box, Flex, Heading, Image, keyframes } from '@chakra-ui/react'

const scrollLeftToRight = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
`

export function PartnerSection(): ReactElement {
  return (
    <Box
      padding="8"
      marginX="auto"
      width="100%"
      data-testid="brand-section"
      maxWidth={APPLICATION_MAX_WIDTH}
    >
      <Heading as="h2" textAlign="center">
        Where Our Mentors Work
      </Heading>
      <Box
        overflow="hidden"
        whiteSpace="nowrap"
        position="relative"
        width="100%"
        my="7"
      >
        <Flex
          as="ul"
          gap="10"
          listStyleType="none"
          animation={`${scrollLeftToRight} 30s linear infinite`}
          width="max-content"
          alignItems="center"
          willChange="transform"
        >
          {/* Display logos twice for seamless looping */}
          {[...mentorLogos, ...mentorLogos].map((logo, index) => (
            <Image
              key={index}
              src={logo.icon}
              width="180px"
              objectFit="contain"
              flexShrink={0}
              data-testid="logo"
              alt={logo.name}
            />
          ))}
        </Flex>
      </Box>
    </Box>
  )
}
